<template>
  <router-view />
</template>

<script setup>
// Root component
</script>
